import { createSlice } from "@reduxjs/toolkit";
import { getSingleAllCertificates } from "./CertificatesActions";

const initialState = {
  certificates: {},
  getCertificatesLoading: false,
  getCertificatesSuccess: false,
  getCertificatesError: null,

  //single certificates
  getSingleCertificateLoading: false,
  getSingleCertificateSuccess: false,
  getSingleCertificateError: null,
  singleCertificate: {},
};

const CertificatesReducer = createSlice({
  name: "Certificates",
  initialState,
  reducers: {
    // Get All Certificates
    getCertificatesRequest: (state) => {
      state.getCertificatesLoading = true;
      state.getCertificatesSuccess = false;
      state.getCertificatesError = null;
    },
    getCertificatesSuccess: (state, action) => {
      state.getCertificatesLoading = false;
      state.getCertificatesSuccess = true;
      state.certificates = action.payload;
    },
    getCertificatesError: (state, action) => {
      state.getCertificatesLoading = false;
      state.getCertificatesSuccess = false;
      state.getCertificatesError = action.payload;
      state.certificates = {};
    },

    // Get Single Certificate
    getSingleCertificateRequest: (state) => {
      state.getSingleCertificateLoading = true;
      state.getSingleCertificateSuccess = false;
      state.getSingleCertificateError = null;
    },
    getSingleCertificateSuccess: (state, action) => {
      state.getSingleCertificateLoading = false;
      state.getSingleCertificateSuccess = true;
      state.singleCertificate = action.payload;
    },
    getSingleCertificateError: (state, action) => {
      state.getSingleCertificateLoading = false;
      state.getSingleCertificateSuccess = false;
      state.getSingleCertificateError = action.payload;
      state.singleCertificate = {};
    },
    //clear state
    clearState: (state) => {
      state.getCertificatesError = null;
      state.getCertificatesSuccess = false;

      state.getSingleCertificateError = null;
      state.getSingleCertificateSuccess = false;
    },
  },
});
export const CertificatesActions = CertificatesReducer.actions;

export default CertificatesReducer.reducer;
